import styled from "styled-components";
import "@fontsource/jetbrains-mono";

export const ButtonText = styled.label`
  text-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
`;

export const CustomModal = styled.div`
  .ba-modal-card {
    width: 320px;
    height: auto;
    max-height: 90vh;
    background: #f1f6ff;
    padding: 20px 10px 20px 20px;

    .ba-modal-card-head {
      padding-right: 10px;

      .ba-flex {
        builderall-icon {
          --builderall-icon-size: 20px;
          --builderall-icon-color: #0072e1;
          margin-right: 20px;
          cursor: pointer;
        }

        .ba-modal-card-title {
          font-family: Montserrat;
          font-weight: 700;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #434343;
        }
      }

      p {
        font-family: Montserrat;
        font-weight: 600;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0%;
        color: #6e6e6e;
        margin-top: 16px;
      }
    }

    .ba-modal-card-body {
      height: auto;
      gap: 20px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      padding-right: 10px;

      .form-group {
        .group-label {
          font-family: Montserrat;
          font-weight: 600;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #6e6e6e;
          margin-bottom: 6px;
          display: flex;
        }

        .ba-input {
          background: white;
          width: 100%;
          border: 1px solid #e4eaf4;
        }

        .ba-bg-white1 {
          padding: 10px;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .ba-flex {
            .ba-radio {
              margin-right: 10px;
              accent-color: #3f51b5;
            }

            .ba-radio-text {
              font-family: Montserrat;
              font-weight: 500;
              font-size: 12px;
              line-height: 100%;
              letter-spacing: 0%;
              color: #6e6e6eee;
            }
          }

          &.ba-pd-1 {
            flex-direction: row;
          }

          .ba-input-range {
            border: 1px solid #d5dee9;
            background: #fafbfc;
            font-family: Montserrat;
            font-weight: 600;
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0px;
            vertical-align: middle;
            color: #6688ae;
            width: 60px;
            aspect-ratio: 1;
            text-align: center;
            -moz-appearance: textfield;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }

        .ba-preview-image {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 2px;
          padding: 20px;

          &:hover {
            .ba-relative {
              .ba-rounded-image {
                filter: brightness(0.5);
                transition: all 0.3s ease-in-out;
              }

              builderall-icon {
                display: flex;
              }
            }
          }

          .ba-rounded-image {
            border-radius: 100%;
            width: 146px;
            aspect-ratio: 1;
            margin: auto;
            object-fit: cover;
          }

          .ba-relative {
            display: flex;

            &:not(:has(.ba-rounded-image)) {
              builderall-icon {
                display: flex;
                --builderall-icon-color: #0072e1;
              }
            }

            builderall-icon,
            #input_image {
              display: none;
              --builderall-icon-size: 20px;
              --builderall-icon-color: #8e9eb5;
              position: absolute;
              top: 50%;
              right: 50%;
              transform: translate(50%, -50%);
              background: #eef2f5;
              border-radius: 100%;
              width: 30px;
              aspect-ratio: 1;
              cursor: pointer;
            }
          }
        }
      }

      .detail-group {
        p {
          font-family: Montserrat;
          font-weight: 600;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #6e6e6e;
          margin-bottom: 6px;
        }

        span {
          font-family: Montserrat;
          font-weight: 600;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #0080fc;
        }
      }

      .script-text {
        p {
          font-family: Montserrat;
          font-weight: 600;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #6e6e6e;
        }

        article {
          border: 1px solid #e4eaf4;
          background: #ffffff;
          padding: 7px 31px 7px 7px;
          position: relative;

          span {
            font-family: JetBrains Mono;
            font-weight: 500;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #0080fc;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          builderall-icon {
            --builderall-icon-size: 20px;
            --builderall-icon-color: #0072e1;
            position: absolute;
            bottom: 10px;
            right: 10px;
            cursor: pointer;
          }
        }

        > span {
          font-family: Montserrat;
          font-weight: 400;
          font-size: 11px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #6e6e6e;
          margin-top: 20px;
          display: block;
        }
      }
    }

    .ba-modal-card-footer {
      padding-right: 10px;
    }
  }
`;
